// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets-kios/css/slick-theme.css
// module id = 1526
// module chunks = 173